/* eslint-disable react/jsx-max-depth */
/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { isTrue, stripSpecialChar } from '@root/utility'

import { handleChange } from '@/Form/Functions/eventsHandling'

import FormElement from '@/Form/toolkit/FormElement'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import SearchBar from '@Pure/SearchBar'
import Loader    from '@Pure/Loader'
import Image     from '@Pure/Image'

const { app, qwest } = window;

export default class ECProductAbondementPage extends Component
{
	state =
	{
		searched:
		{
			value: ''
		},

		products: [],
		selected_products: [],
		can_compute: true,

		abondement_value: '0',
		abondement_qty: 0,
		existing_abondements: [],

		form_data: { },
		status_messages: { }
	};

	handleOccurenceChange = handleChange.bind(this);

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		app.push(
		{
			event: 'createdProductAbondement',
			cb: component.handleCreation
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		// lunrjs.com/guides/customising.html#pipeline-functions
		let normaliseSpelling = function (builder)
		{
			let pipelineFunction = function (token)
			{
				return token.update(function ()
				{
					return stripSpecialChar(token.toString());
				});
			};

		// Register the pipeline function so the index can be serialised
			window.lunr.Pipeline.registerFunction(pipelineFunction, 'normaliseSpelling')

		// Add the pipeline function to both the indexing pipeline and the
		// searching pipeline
			builder.pipeline.before(window.lunr.stemmer, pipelineFunction)
			builder.searchPipeline.before(window.lunr.stemmer, pipelineFunction)
		}

		component.setState(
		{
			can_compute: true
		});

		component.handleSessionChange();

		qwest.post('/fetch/list-products-for-abondement')
		.then(function (xhr, response)
		{
			const products = response.products || [];

			component.lunr = window.lunr(function ()
			{
				this.use(normaliseSpelling);

				this.ref('id');

				this.field('name', { boost: 10 });
				this.field('description');
				this.field('_artist');
				this.field('_places');
				this.field('_themes');

				products.forEach(function (doc)
				{
					this.add(doc);
				}, this);
			});

			component.setState(
			{
				products: products,
				can_compute: true
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'createdProductAbondement',
			cb: component.handleCreation
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleCreation = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		state.existing_abondements.push(data.abondement);

		component.setState(
		{
			searched:
			{
				value: ''
			},

			selected_products: [],
			can_compute: true,

			abondement_value: '0',
			abondement_qty: 0,
			existing_abondements: state.existing_abondements,

			form_data: { },
			status_messages: { }
		});
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (app.state.session.EC && state.existing_abondements.length === 0)
		{
			qwest.post('/CMS/getAll',
			{
				model: 'abondement',
				filter_query: JSON.stringify(
				{
					EC: app.state.session.EC.id,
					type: 'product'
				})
			})
			.then(function (xhr, response)
			{
				component.setState(
				{
					existing_abondements: response.data
				});
			})
			.catch(function (error, xhr, response)
			{
				app.ajaxRedirectLogin(response);

				console.error(error);
			});
		}
	}

	handleSearch = (value, search) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			searched:
			{
				value: value
			},
			can_compute: value !== '' ? false : true
		});

	// Prevent to search each letter typed and wait a bit.
		if (component.computation)
		{
			window.clearTimeout(component.computation);

			component.computation = window.setTimeout(component.enableComputation, 320);
		}
		else
		{
			if (value !== '')
			{
				component.computation = window.setTimeout(component.enableComputation, 320);
			}
		}
	}

	enableComputation = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			can_compute: true
		});
	}

	selectProduct = (e, product) =>
	{
		const component = this, props = this.props, state = this.state;

		let removed = false;

		state.selected_products = state.selected_products
		.filter(function (state_product)
		{
			if (state_product.id === product.id)
			{
				removed = true;

				return false;
			}

			return true;
		});

		if (removed === false)
		{
			state.selected_products.push(product);
		}

		component.setState(
		{
			selected_products: state.selected_products
		});
	}

	unSelectProduct = (e, product) =>
	{
		const component = this, props = this.props, state = this.state;

		state.selected_products = state.selected_products
		.filter(function (state_product)
		{
			return state_product.id !== product.id;
		});

		component.setState(
		{
			selected_products: state.selected_products
		});
	}

	changeAbondementQty = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		if (e === 'less')
		{
			state.abondement_qty--;
		}
		else if (e === 'more')
		{
			state.abondement_qty++;
		}
		else if (e)
		{
			let qty = e.target.value;

			state.abondement_qty = Number(qty);
		}

		if (Number(state.abondement_qty) <= 0)
		{
			state.abondement_qty = 0;
		}

		component.setState(
		{
			abondement_qty: state.abondement_qty,
			abondement_value: state.abondement_value,
			abondement_loading: true
		});
	}

	changeAbondementValue = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		if (e)
		{
			let value = e.target.value.trim();

			state.abondement_value = value;
		}

		if (Number(state.abondement_value) < 0)
		{
			state.abondement_value = '0';
		}

		component.setState(
		{
			abondement_qty: state.abondement_qty,
			abondement_value: state.abondement_value,
			abondement_loading: true
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let search_results, searched_products = [], search_message;

		if (state.can_compute && component.lunr)
		{
			search_results = component.lunr
			.search(stripSpecialChar(state.searched.value));

			searched_products = state.products
			.filter(function (product)
			{
				let find = search_results.find(data => data.ref === product.id);

				return typeof find !== 'undefined';
			});

			let existing_hidden = false;

			searched_products = searched_products
			.filter(function (product)
			{
				let has_already_abondement = false;

				state.existing_abondements.find(function (abondement)
				{
					if ((abondement.products || []).includes(product.id))
					{
						has_already_abondement = true;

						existing_hidden = true;

						return true;
					}
				});

				return has_already_abondement === false;
			});

			if (existing_hidden === true)
			{
				search_message =
				(
					<div className="o-content">
						<div className="c-message c-message--orange u-no-margin-top">
							<div className="c-message__content">
								Les produits déjà abondés sont masqués de la recherche.
							</div>
						</div>
					</div>
				);
			}
		}

		searched_products = searched_products.map(renderSearchProduct);

		let selected_products = state.selected_products.map(renderSelectedProduct);

		const search_loader = state.can_compute === false ?
		(
			<Loader className="c-loader abondement-search"
				bemit={ ['white', 'bg-primary'] }
			/>
		)
		: undefined;

		let abondement =
		(
			<div className="c-abondement">

				<div className="o-grid-2">

					<div className="o-grid__item">

						<div className="c-abondement-price">
							<strong className="u-margin-right-10">
								Montant de chaque abondement&nbsp;:
							</strong>

							<input type="text"
								className="c-qty__input"
								value={ state.abondement_value }
								onChange={ function (e)
									{ component.changeAbondementValue(e); } } />
							&nbsp;€
						</div>

						<div className="c-abondement-qty">

							<div className="c-qty c-qty--abondement">
								<strong>Quantité par membre&nbsp;:</strong>
								<button type="button" className="c-qty__less"
									onClick={ function (e)
										{ component.changeAbondementQty('less'); }
									}>
									-
								</button>

								<input type="text"
									className="c-qty__input"
									value={ state.abondement_qty }
									onChange={ function (e)
										{ component.changeAbondementQty(e); } } />

								<button type="button" className="c-qty__more"
									onClick={ function (e)
										{ component.changeAbondementQty('more'); } }>
									+
								</button>
							</div>

						</div>

					</div>

					<div className="o-grid__item">

						<div className="c-abondement-recurrence">

							<div className="c-abondement-recurrence-label">
								<strong>Récurrence&nbsp;:</strong>
							</div>

							<div className="c-abondement-recurrence-choices">

								<div className="c-checkbox-filter">

									<FormElement className="c-form-element c-form-element--inline"
										name="abondement-recurrence" type="radio"
										data={ state.form_data }
										label="Aucun ( valable une fois pour la quantité définie)" status={ state.status_messages }
										onChange={ component.handleOccurenceChange }
										radio_value="unique" checked={ true } />

								</div>

								<div className="c-checkbox-filter">

									<FormElement className="c-form-element c-form-element--inline"
										name="abondement-recurrence" type="radio"
										data={ state.form_data }
										label="Mensuel" status={ state.status_messages }
										onChange={ component.handleOccurenceChange }
										radio_value="month" />

								</div>

								<div className="c-checkbox-filter">

									<FormElement className="c-form-element c-form-element--inline"
										name="abondement-recurrence" type="radio"
										data={ state.form_data }
										label="Annuel" status={ state.status_messages }
										onChange={ component.handleOccurenceChange }
										radio_value="year" />

								</div>

							</div>

						</div>

					</div>

				</div>

			</div>
		);

		if (selected_products.length === 0)
		{
			selected_products =
			(
				<div className="o-content">

					<div className="c-message c-message--green">
						<div className="c-message__content">
							Aucun produit sélectionné pour le moment.
						</div>
					</div>

				</div>
			);
		}
		else
		{
			selected_products =
			(
				<div className="o-grid-4">
					{ selected_products }
				</div>
			);
		}

		var output =
		(
			<Layout history={ props.history } page_title="Abondement produit">

				<div className="page-content abondement-product-admin">

					<HolidaysMessage />

					<div className="o-content">

						<div className="c-title u-no-margin-top">
							<h2 className="c-title__txt">
								1. Sélection des produits à abonder
							</h2>
						</div>

						<div className="abondement-searchbar">
							<SearchBar className="c-searchbar c-searchbar--front u-no-margin-bottom"
								hide_btn={ true } placeholder="Recherche..."
								data={ [] }
								handleChange={ component.handleSearch }
								value={ state.searched.value }
							/>
						</div>

					</div>

					{ search_message }

					<div className="o-grid-4 u-positioned">
						{ searched_products }
						{ search_loader }
					</div>

					<div className="o-content u-margin-top-20">
						<div className="c-title u-no-margin-top">
							<h2 className="c-title__txt">
								2. Règles de l'abondement
							</h2>
						</div>

						{ abondement }
					</div>

					<div className="o-content u-margin-top-20">

						<div className="c-subtitle c-subtitle u-no-margin-top">
							<h2 className="c-subtitle__txt">
								Produits sélectionnés
							</h2>
						</div>

					</div>

					{ selected_products }

					<div className="o-content u-margin-top-20">

						<button type="button" className="c-btn c-btn--extra"
							onClick={ function (e)
								{
									app.emit('open__CreateAbondementModal',
									{
										products: state.selected_products.map(p => p.id),
										value: state.abondement_value,
										qty: state.abondement_qty,
										recurrence: state.form_data['abondement-recurrence']
									});
								}
							}>
							Créer cet abondement
						</button>
					</div>

				</div>

			</Layout>
		);

		return output;

		function renderSearchProduct (product)
		{
			return renderProduct(product, 'search');
		}

		function renderSelectedProduct (product)
		{
			return renderProduct(product, 'selection');
		}

		function renderProduct (product, type)
		{
			let image = (product.images || [])[0];

			if (image)
			{
				image =
				(
					<Image className="c-search-view-item__img" src={ image.url } />
				);
			}

			let selected;

			if (type === 'search')
			{
				selected = state.selected_products
				.find(data => data.id === product.id);

				selected = typeof selected === 'undefined' ? false : true;
			}

			let content =
			(
				<>
					{ image }

					<div className="c-search-view-item__content">
						<div className="c-search-view-item__title">
							{ product.name }
						</div>
					</div>
				</>
			);

			let output =
			(
				<>
					<div className={ 'c-search-view-item u-flex-grow-1' +
						(selected ? ' selected' : '') }
						onClick={ function (e) { component.selectProduct(e, product) } }
						style={ { cursor: 'pointer' } }>

						{ content }

					</div>

					{
						isTrue(product.disabled) ?
						(
							<div className="c-search-view-item__disabled">
								Produit désactivé.
							</div>
						)
						: undefined
					}
				</>
			);

			if (type === 'selection')
			{
				output =
				(
					<>
						<div className="c-search-view-item u-flex-grow-1">
							{ content }
						</div>

						<div className="u-text-right u-overflow-hidden">
							<button type="button"
								className="c-btn c-btn--delete c-btn--collapsible"
								onClick={ function (e) { component.unSelectProduct(e, product); } }>
								Enlever de la sélection
							</button>
						</div>
					</>
				);
			}

			return (
				<div className="o-grid__item u-flex u-flex-grow-1 u-flex-column"
					key={ product.id }>
					{ output }
				</div>
			);
		}
	}
}